import ProposalWrapper from './ProposalWrapper';

export default ProposalWrapper;
